module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Light.9e83e42.woff";